document.documentElement.classList.remove('no-js');

const $ = (selector, context = document) => context.querySelector(selector);
const $$ = (selector, context = document) => Array.from(context.querySelectorAll(selector));

function formatMoney(cents, currency = window.Shopify?.currency?.active || 'USD') {
  try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100); }
  catch (_) { return `$${(cents / 100).toFixed(2)}`; }
}

function initMobileMenu() {
  const button = $('[data-menu-toggle]');
  const menu = $('[data-mobile-menu]');
  if (!button || !menu) return;
  button.addEventListener('click', () => {
    const open = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!open));
    menu.hidden = open;
  });
}

const cartDrawer = $('[data-cart-drawer]');
const drawerOverlay = $('[data-drawer-overlay]');

function closeCartDrawer() {
  if (!cartDrawer) return;
  cartDrawer.classList.remove('is-open');
  cartDrawer.setAttribute('aria-hidden', 'true');
  if (drawerOverlay) drawerOverlay.hidden = true;
  document.body.classList.remove('drawer-open');
}

async function openCartDrawer() {
  if (!cartDrawer) return;
  await refreshCartDrawer();
  cartDrawer.classList.add('is-open');
  cartDrawer.setAttribute('aria-hidden', 'false');
  if (drawerOverlay) drawerOverlay.hidden = false;
  document.body.classList.add('drawer-open');
}

async function refreshCartDrawer() {
  const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
  $$('[data-header-cart-count]').forEach(el => { el.textContent = cart.item_count; });
  $$('[data-cart-count]').forEach(el => { el.textContent = `(${cart.item_count})`; });
  const body = $('[data-cart-body]');
  const footer = $('.mbo-cart-drawer__footer');
  if (!body) return cart;
  if (!cart.items.length) {
    body.innerHTML = '<p class="mbo-cart-empty">Your cart is empty</p>';
    if (footer) footer.hidden = true;
    return cart;
  }
  body.innerHTML = cart.items.map((item, index) => `
    <article class="mbo-cart-line" data-line-key="${item.key}">
      ${item.image ? `<img src="${item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_180x$1')}" alt="">` : ''}
      <div><a href="${item.url}">${item.product_title}</a>${item.variant_title && item.variant_title !== 'Default Title' ? `<small>${item.variant_title}</small>` : ''}<div>${formatMoney(item.final_line_price)}</div><label class="visually-hidden" for="ajax-drawer-qty-${index}">Quantity</label><input id="ajax-drawer-qty-${index}" type="number" min="0" value="${item.quantity}" data-cart-quantity data-key="${item.key}"></div>
    </article>`).join('');
  if (footer) footer.hidden = false;
  const total = $('[data-cart-total]');
  if (total) total.textContent = formatMoney(cart.total_price);
  return cart;
}

function initCart() {
  $$('[data-cart-open]').forEach(button => button.addEventListener('click', openCartDrawer));
  $$('[data-cart-close]').forEach(button => button.addEventListener('click', closeCartDrawer));
  drawerOverlay?.addEventListener('click', closeCartDrawer);
  document.addEventListener('mbo:cart-added', openCartDrawer);
  document.addEventListener('cart:refresh', refreshCartDrawer);
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeCartDrawer(); });
  document.addEventListener('change', async event => {
    const input = event.target.closest('[data-cart-quantity]');
    if (!input) return;
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: input.dataset.key, quantity: Number(input.value) }) });
    await refreshCartDrawer();
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    const button = $('[type="submit"]', form);
    const original = button?.textContent;
    if (button) { button.disabled = true; button.textContent = 'ADDING…'; }
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error((await response.json()).description || 'Unable to add this item.');
      await openCartDrawer();
    } catch (error) {
      const errorBox = $('[data-product-error]', form);
      if (errorBox) { errorBox.hidden = false; errorBox.textContent = error.message; } else alert(error.message);
    } finally {
      if (button) { button.disabled = false; button.textContent = original; }
    }
  });
}

function initCarousels() {
  $$('[data-carousel]').forEach(carousel => {
    const track = $('[data-carousel-track]', carousel);
    if (!track) return;
    const items = Array.from(track.children);
    const dots = $('.mbo-carousel__dots', carousel);
    let active = 0;
    if (dots) {
      dots.innerHTML = items.map((_, index) => `<button type="button" aria-label="Go to slide ${index + 1}" class="${index === 0 ? 'is-active' : ''}"></button>`).join('');
      $$('button', dots).forEach((button, index) => button.addEventListener('click', () => go(index)));
    }
    const step = () => (items[0]?.getBoundingClientRect().width || track.clientWidth) + parseFloat(getComputedStyle(track).gap || 0);
    const loop = carousel.dataset.carouselLoop !== 'false';
    const updateControls = () => {
      const previous = $('[data-carousel-prev]', carousel);
      const next = $('[data-carousel-next]', carousel);
      if (!loop && previous) previous.disabled = active === 0;
      if (!loop && next) next.disabled = active === items.length - 1;
    };
    const go = index => {
      if (loop) active = (index + items.length) % items.length;
      else active = Math.max(0, Math.min(index, items.length - 1));
      track.scrollTo({ left: active * step(), behavior: 'smooth' });
      $$('button', dots || document.createElement('div')).forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === active));
      updateControls();
    };
    $('[data-carousel-prev]', carousel)?.addEventListener('click', () => go(active - 1));
    $('[data-carousel-next]', carousel)?.addEventListener('click', () => go(active + 1));
    track.addEventListener('scroll', () => {
      window.clearTimeout(track._mboScrollTimer);
      track._mboScrollTimer = window.setTimeout(() => { active = Math.round(track.scrollLeft / step()); $$('button', dots || document.createElement('div')).forEach((dot, index) => dot.classList.toggle('is-active', index === active)); updateControls(); }, 80);
    }, { passive: true });
    updateControls();
  });
}

function initTestimonialTabs() {
  $$('[data-testimonial-tab]').forEach(button => button.addEventListener('click', () => {
    const section = button.closest('.mbo-testimonials');
    $$('[data-testimonial-tab]', section).forEach(tab => { const active = tab === button; tab.classList.toggle('is-active', active); tab.setAttribute('aria-selected', String(active)); });
    $$('[data-testimonial-panel]', section).forEach(panel => { panel.hidden = panel.dataset.testimonialPanel !== button.dataset.testimonialTab; });
  }));
}

function initProductGallery() {
  $$('[data-product-gallery]').forEach(gallery => {
    const media = $$('[data-product-media]', gallery);
    let index = 0;
    const show = next => {
      index = (next + media.length) % media.length;
      media.forEach((item, itemIndex) => { item.hidden = itemIndex !== index; item.classList.toggle('is-active', itemIndex === index); });
      $$('[data-product-dot]', gallery).forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
    };
    $('[data-product-prev]', gallery)?.addEventListener('click', () => show(index - 1));
    $('[data-product-next]', gallery)?.addEventListener('click', () => show(index + 1));
    $$('[data-product-dot]', gallery).forEach((dot, dotIndex) => dot.addEventListener('click', () => show(dotIndex)));
    if (media.length) show(0);
  });
}

function initVariants() {
  $$('[data-product-root]').forEach(root => {
    const cards = $$('[data-variant-card]', root);
    const select = $('[data-variant-select]', root);
    const idInput = $('input[name="id"]', root);
    const price = $('[data-product-price]', root);
    const compare = $('[data-product-compare]', root);
    const addButton = $('[data-add-to-cart]', root);
    const stock = $('[data-stock-label]', root);
    const choose = variantId => {
      const card = cards.find(item => String(item.dataset.variantId) === String(variantId));
      if (!card) return;
      cards.forEach(item => { const selected = item === card; item.classList.toggle('is-selected', selected); item.setAttribute('aria-pressed', String(selected)); });
      if (select) select.value = variantId;
      if (idInput) idInput.value = variantId;
      if (price) price.textContent = card.dataset.price;
      if (compare) { compare.textContent = card.dataset.compare || ''; compare.hidden = !card.dataset.compare; }
      const available = card.dataset.available === 'true';
      if (addButton) { addButton.disabled = !available; addButton.textContent = available ? (addButton.dataset.label || 'ADD TO CART') : 'OUT OF STOCK'; }
      if (stock) stock.textContent = available ? 'In stock' : 'Out of stock';
      const url = new URL(window.location.href); url.searchParams.set('variant', variantId); window.history.replaceState({}, '', url);
    };
    cards.forEach(card => card.addEventListener('click', () => choose(card.dataset.variantId)));
    select?.addEventListener('change', () => choose(select.value));
    if (cards.length) {
      const requested = new URLSearchParams(location.search).get('variant');
      choose(cards.some(card => card.dataset.variantId === requested) ? requested : (root.dataset.defaultVariant || cards[0].dataset.variantId));
    }
  });
}

function initAccordions() {
  $$('[data-accordion-button]').forEach(button => button.addEventListener('click', () => {
    const item = button.closest('[data-accordion-item]');
    const panel = $('[data-accordion-panel]', item);
    const open = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!open));
    item.classList.toggle('is-open', !open);
    panel.hidden = open;
  }));
}

function initScrollLinks() {
  $$('[data-scroll-buybox]').forEach(link => link.addEventListener('click', event => {
    const target = $('#ProductBuyBox');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }));
}

function initSearchModal() {
  const modal = $('[data-search-modal]');
  if (!modal) return;
  const open = () => {
    modal.hidden = false;
    document.body.classList.add('mbo-modal-open');
    window.setTimeout(() => $('input[type="search"]', modal)?.focus(), 30);
  };
  const close = () => {
    modal.hidden = true;
    document.body.classList.remove('mbo-modal-open');
  };
  $$('[data-search-open]').forEach(button => button.addEventListener('click', open));
  $$('[data-search-close]', modal).forEach(button => button.addEventListener('click', close));
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && !modal.hidden) close(); });
}

document.addEventListener('DOMContentLoaded', () => {
  initMobileMenu();
  initCart();
  initCarousels();
  initTestimonialTabs();
  initProductGallery();
  initVariants();
  initAccordions();
  initScrollLinks();
  initSearchModal();
});

/* Product detail: main purchase section */
(() => {
  const SELECTOR = '[data-mbo-product]';

  function formatMoney(cents, format) {
    const value = Number(cents || 0);
    const template = format || ('$' + '{' + '{' + 'amount' + '}' + '}');
    const token = (template.match(/\{\{\s*(\w+)\s*\}\}/) || [null, 'amount'])[1];
    const withDelimiters = (number, precision, thousands, decimal) => {
      const fixed = (number / 100).toFixed(precision);
      const parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    };
    const rendered = {
      amount: withDelimiters(value, 2, ',', '.'),
      amount_no_decimals: withDelimiters(value, 0, ',', '.'),
      amount_with_comma_separator: withDelimiters(value, 2, '.', ','),
      amount_no_decimals_with_comma_separator: withDelimiters(value, 0, '.', ','),
      amount_with_apostrophe_separator: withDelimiters(value, 2, "'", '.')
    }[token] || withDelimiters(value, 2, ',', '.');
    return template.replace(/\{\{\s*\w+\s*\}\}/, rendered);
  }

  function initProduct(root) {
    if (!root || root.dataset.mboReady === 'true') return;
    root.dataset.mboReady = 'true';

    const track = root.querySelector('[data-mbo-media-track]');
    const slides = [...root.querySelectorAll('[data-mbo-media-slide]')];
    const dots = [...root.querySelectorAll('[data-mbo-media-dot]')];
    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));

    const showSlide = (index) => {
      if (!slides.length || !track) return;
      activeIndex = (index + slides.length) % slides.length;
      track.style.transform = `translate3d(-${activeIndex * 100}%,0,0)`;
      slides.forEach((slide, i) => {
        const active = i === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        if (!active) slide.querySelectorAll('video').forEach((video) => video.pause());
      });
      dots.forEach((dot, i) => {
        const active = i === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', String(active));
      });
    };

    root.querySelector('[data-mbo-media-prev]')?.addEventListener('click', () => showSlide(activeIndex - 1));
    root.querySelector('[data-mbo-media-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));
    dots.forEach((dot) => dot.addEventListener('click', () => showSlide(Number(dot.dataset.mboMediaDot))));
    showSlide(activeIndex);

    let touchStartX = null;
    track?.addEventListener('touchstart', (event) => { touchStartX = event.touches[0]?.clientX ?? null; }, { passive: true });
    track?.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const delta = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
      if (Math.abs(delta) > 45) showSlide(activeIndex + (delta < 0 ? 1 : -1));
      touchStartX = null;
    }, { passive: true });

    const variantInput = root.querySelector('[data-mbo-variant-input]');
    const price = root.querySelector('[data-mbo-price]');
    const compare = root.querySelector('[data-mbo-compare]');
    const atc = root.querySelector('[data-mbo-atc]');
    const atcLabel = root.querySelector('[data-mbo-atc-label]');
    const stock = root.querySelector('[data-mbo-stock]');
    const stockDot = root.querySelector('[data-mbo-stock-dot]');
    const moneyFormat = root.dataset.moneyFormat;

    root.querySelectorAll('[data-mbo-variant]').forEach((card) => {
      card.addEventListener('click', () => {
        if (card.dataset.available !== 'true') return;
        root.querySelectorAll('[data-mbo-variant]').forEach((item) => {
          const selected = item === card;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-checked', String(selected));
        });
        if (variantInput) variantInput.value = card.dataset.variantId;
        if (price) price.textContent = formatMoney(card.dataset.price, moneyFormat);
        const compareValue = Number(card.dataset.comparePrice || 0);
        const priceValue = Number(card.dataset.price || 0);
        if (compare) {
          compare.textContent = compareValue > priceValue ? formatMoney(compareValue, moneyFormat) : '';
          compare.classList.toggle('is-hidden', compareValue <= priceValue);
        }
        if (atc) atc.disabled = false;
        if (atcLabel) atcLabel.textContent = atc?.dataset.addLabel || 'ADD TO CART';
        if (stock) stock.textContent = (root.dataset.inStockLabel || 'In stock');
        stockDot?.classList.remove('is-unavailable');
        const mediaId = card.dataset.mediaId;
        if (mediaId) {
          const mediaIndex = slides.findIndex((slide) => slide.dataset.mediaId === mediaId);
          if (mediaIndex >= 0) showSlide(mediaIndex);
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', card.dataset.variantId);
        window.history.replaceState({}, '', url);
      });
    });

    root.querySelectorAll('[data-mbo-accordion]').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        root.querySelectorAll('[data-mbo-accordion]').forEach((other) => {
          if (other !== details) other.removeAttribute('open');
        });
      });
    });

    const form = root.querySelector('.mbo-product-form');
    const status = root.querySelector('[data-mbo-atc-status]');
    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!atc || atc.disabled || atc.classList.contains('is-loading')) return;
      atc.classList.add('is-loading');
      atc.disabled = true;
      status?.classList.remove('is-error');
      if (status) status.textContent = '';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        });
        const item = await response.json();
        if (!response.ok) throw new Error(item.description || item.message || 'Unable to add this item.');
        if (status) status.textContent = (root.dataset.addedMessage || 'Added to your cart.');
        if (atcLabel) atcLabel.textContent = (root.dataset.addedLabel || 'ADDED ✓');
        document.dispatchEvent(new CustomEvent('mbo:cart-added', { detail: { item } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { item } }));
        try {
          const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((res) => res.json());
          document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden="true"]').forEach((node) => { node.textContent = cart.item_count; });
        } catch (_) {}
        setTimeout(() => { if (atcLabel) atcLabel.textContent = atc.dataset.addLabel || 'ADD TO CART'; }, 1800);
      } catch (error) {
        if (status) {
          status.textContent = error.message;
          status.classList.add('is-error');
        }
      } finally {
        atc.classList.remove('is-loading');
        atc.disabled = false;
      }
    });
  }

  const initAll = (scope = document) => {
    if (scope.matches?.(SELECTOR)) initProduct(scope);
    scope.querySelectorAll?.(SELECTOR).forEach(initProduct);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  if (!window.__mboProductSectionListener) {
    window.__mboProductSectionListener = true;
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  }
})();

/* Product detail: long-form story section */
(() => {
  const initStory = (root) => {
    if (!root || root.dataset.mboStoryReady === 'true') return;
    root.dataset.mboStoryReady = 'true';
    const track = root.querySelector('[data-mbo-video-track]');
    const scrollCards = (direction) => {
      if (!track) return;
      const card = track.querySelector('.mbo-video-card');
      track.scrollBy({ left: direction * ((card?.getBoundingClientRect().width || track.clientWidth * .8) + 18), behavior: 'smooth' });
    };
    root.querySelector('[data-mbo-story-prev]')?.addEventListener('click', () => scrollCards(-1));
    root.querySelector('[data-mbo-story-next]')?.addEventListener('click', () => scrollCards(1));
    const videoDots = Array.from(root.querySelectorAll('[data-mbo-video-dot]'));
    const setActiveVideoDot = (index) => {
      videoDots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };
    videoDots.forEach((dot) => dot.addEventListener('click', () => {
      const card = track?.querySelectorAll('.mbo-video-card')[Number(dot.dataset.mboVideoDot)];
      if (!card || !track) return;
      track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActiveVideoDot(Number(dot.dataset.mboVideoDot));
    }));
    track?.addEventListener('scroll', () => {
      const cards = Array.from(track.querySelectorAll('.mbo-video-card'));
      if (!cards.length) return;
      const nearest = cards.reduce((best, card, index) => {
        const distance = Math.abs(card.offsetLeft - track.offsetLeft - track.scrollLeft);
        return distance < best.distance ? { index, distance } : best;
      }, { index: 0, distance: Infinity });
      setActiveVideoDot(nearest.index);
    }, { passive: true });
    root.querySelectorAll('[data-mbo-story-cta]').forEach((link) => {
      if (!link.getAttribute('href')?.startsWith('#mbo-buy')) return;
      link.addEventListener('click', (event) => {
        const target = document.querySelector('[data-mbo-product]');
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    root.querySelectorAll('[data-mbo-story-faq] details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        root.querySelectorAll('[data-mbo-story-faq] details').forEach((other) => {
          if (other !== details) other.removeAttribute('open');
        });
      });
    });
  };
  const initAll = (scope = document) => {
    const selector = '[data-mbo-product-story]';
    if (scope.matches?.(selector)) initStory(scope);
    scope.querySelectorAll?.(selector).forEach(initStory);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  if (!window.__mboStorySectionListener) {
    window.__mboStorySectionListener = true;
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  }
})();
